/**
 * 环境
 */
import { isAppletEnvi } from "@utils/plat";
// 是否为小程序
export let isApplet = false;
// 判断是否为小程序
isAppletEnvi(_isApplet => {
    isApplet = _isApplet;
});
